import React, { useState, useEffect } from 'react';
import BannerEstreno from './components/BannerEstreno';
import Carrusel from './components/CarruselDestacados';
import Top10Carrusel from './components/Top10';
import { getGaleriaVideos} from '../../http/Actions/VideoShowAction';
import backgroundImage from "../../../images/stupid-comedy-bg1.jpg";

const Home = () => {
  const [galeria, setGaleria] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('token');

    getGaleriaVideos(
      (response) => {
        if (response?.status === 200 && response.data) {
          setGaleria(response.data);
        } else {
          setError('Formato de respuesta inesperado');
        }
      },
      (err) => setError(err?.message || 'Error al cargar la galería'),
      token
    );
  }, []);

  if (error) {
    return (
      <div className="p-4 bg-red-50 border-l-4 border-red-500 text-red-700 rounded">
        {error}
      </div>
    );
  }

  if (!galeria) {
    // skeleton simple
    return (
      <div className="min-h-screen grid place-items-center text-gray-300">
        Cargando...
      </div>
    );
  }

  return (
    <div
      className="text-white min-h-screen"
      style={{

        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed',
        backgroundRepeat: 'no-repeat',
        position: 'relative'
      }}
    >
      <div className="absolute inset-0" style={{ backgroundColor: 'rgba(0,0,0,0.75)' }} />
      <div className="relative z-10">
        {/* Ahora BannerEstreno recibe los estrenos */}
        <BannerEstreno shows={galeria.estrenos || []} />

        <div className="space-y-8 p-4 sm:p-6 md:p-8">
          {/* “Destacados” desde la galería */}
          <Carrusel title="Shows destacados" shows={galeria.destacados || []} />

          {/* Top 10 desde la galería */}
          <Top10Carrusel shows={galeria.topMasVistos?.slice(0, 10) || []} />

          {/* PorTag: render dinámico de carruseles según los tags que entregue el backend */}
          {galeria.porTag && Object.entries(galeria.porTag).map(([tagName, items]) => (
            <Carrusel key={tagName} title={tagName} shows={items || []} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Home;
